import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Message, SpinnerService } from 'shared-components';
import { AdminContextService } from '../../context/admin-contex.service';
import { AdminService } from '../../services/admin.service';
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-versiones-etiquetado',
    templateUrl: './mantenimiento-versiones-etiquetado.component.html'
})
export class MantenimientoVersionesEtiquetadoComponent implements OnInit {

    private readonly _DEFAULT_ITEMS_PER_PAGE = 10;

    private _filters;
    public filtersVisible = false;
    public filtersForm: UntypedFormGroup;

    public versionesSw;
    public versionSwId;
    public lsActualizacionAutomatica;
    public paisActualizacionId;
    public denominacionActualizacionId;

    public mensajes = new Array<Message>();
    public showError: boolean;

    public dropdownInfo: number;
    public dropdownSection: number;

    public deleteModal = false;
    public newEditModal = false;
    public deleteActualizacionesModal = false;
    public uploadModal = false;

    public updateFile: boolean;

    public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
    public currentPage = 0;
    public totalItems: number;
    public readonly visiblePages = 3;

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _adminContext: AdminContextService,
        private readonly _adminService: AdminService,
        private readonly _sessionContext: SessionContextService,
        private readonly _translate: TranslateService
    ) { }

    async ngOnInit() {
        this.filtersForm = this._fb.group({
            observaciones: ['']
        });

        this._adminContext.manteimientoVersionesEtiquetadoFilters = null;

        this.getVersionesEtiquetado();

    }

    public get isSmallScreen() {
        return this._sessionContext.isSmallScreen();
    }

    public get defaultLanguage() {
        return this._translate.getDefaultLang();
    }

    public checkValuesForm(): boolean {
        return this.filtersForm.get('observaciones').value ? true : false;
    }

    public filtrar() {
        if (this.filtersForm.valid) {
            this.applyFilters();
        } else {
            this.showError = true;
            this.mensajes.push({ class: 'warning', message: 'global.info.filterRequired' });
        }
    }

    public pageChange(page) {
        this.dropdownSection = -1;
        this.dropdownInfo = -1;
        this._adminContext.manteimientoVersionesEtiquetadoFilters.numPagina = this.currentPage = page - 1;
        this.getVersionesEtiquetado();
    }

    public itemsPerPageChange(items) {
        this.dropdownSection = -1;
        this.dropdownInfo = -1;
        this._adminContext.manteimientoVersionesEtiquetadoFilters.numPagina = this.currentPage = 0;
        this._adminContext.manteimientoVersionesEtiquetadoFilters.tamPagina = this.itemsPerPage = items;
        this.getVersionesEtiquetado();
    }

    public showDetails(i: number) {
        this.dropdownInfo = this.dropdownInfo === i ? -1 : i;
    }

    public openTabs(i) {
        this.dropdownSection = this.dropdownSection === i ? -1 : i;
    }

    public resetForm() {
        this.filtersForm.reset();
    }

    public applyFilters() {
        this.currentPage = 0;
        this.dropdownSection = -1;
        this.dropdownInfo = -1;
        this._adminContext.manteimientoVersionesEtiquetadoFilters = {
            observaciones: this.filtersForm.get('observaciones').value ? this.filtersForm.get('observaciones').value : '',
            cargaActualizacionesAutomaticas: true,
            numPagina: this.currentPage,
            tamPagina: this.itemsPerPage,
        };

        this.getVersionesEtiquetado();
    }

    public getVersionesEtiquetado() {
        this.dropdownSection = -1;
        this.dropdownInfo = -1;
        if (this._adminContext.manteimientoVersionesEtiquetadoFilters) {
            this._filters = this._adminContext.manteimientoVersionesEtiquetadoFilters;
        } else {
            this.applyFilters();
        }
        this._spinnerService.showSpinner();
        this._adminService.getVersionesEtiquetado(this._filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.totalItems = resp.paginacionMeta.totalCount;
            this.versionesSw = resp.lista;
        }, (error) => {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
        });
    }

    public create() {
        this.versionSwId = null;
        this.newEditModal = true;
    }

    public update(versionSw) {
        this.versionSwId = versionSw.id;
        this.newEditModal = true;
    }

    public askDelete(versionSw) {
        this.versionSwId = versionSw.id;
        this.deleteModal = true;
    }

    public askDeleteActualizacion(actualizacion) {
        this.versionSwId = actualizacion.versionSwId;
        this.paisActualizacionId = actualizacion.paisId;
        this.denominacionActualizacionId = actualizacion.denominacionId;
        this.deleteActualizacionesModal = true;
    }

    public delete() {
        this._spinnerService.showSpinner();
        this._adminService.deleteVersionEtiquetado(this.versionSwId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then(() => {
            this.close();
            this.pushMessage('global.success.itemDeleted');
            this.getVersionesEtiquetado();
        });
    }

    public deleteActualizacion() {
        this._spinnerService.showSpinner();
        this._adminService.deleteActualizacionAutomatica(this.versionSwId, this.paisActualizacionId, this.denominacionActualizacionId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then(() => {
            this.close();
            this.pushMessage('global.success.itemDeleted');
            this.getVersionesEtiquetado();
        });
    }

    public close() {
        this.newEditModal = false;
        this.deleteModal = false;
        this.uploadModal = false;
        this.deleteActualizacionesModal = false;
    }

    public openUpload(versionSw, update) {
        this.versionSwId = versionSw.id;
        this.uploadModal = true;
        this.updateFile = update;
    }

    public refresh(value) {
        this.newEditModal = false;
        this.uploadModal = false;
        if (value) {
            this.getVersionesEtiquetado();
        }
    }

    public pushMessage(mensaje) {
        this.showError = true;
        this.mensajes.push({ class: 'success', message:  mensaje });
    }

    public copyInstalador(instalador: any) {
        if (!navigator.clipboard) {
            // use old commandExec() way
        } else {
            navigator.clipboard.writeText(instalador).then(() => {
                this.pushMessage('mantenimientoVersionesEtiquetado.portapapeles');
            });
        }
    }

    public copyActualizador(actualizador: any) {
        if (!navigator.clipboard) {
            // use old commandExec() way
        } else {
            navigator.clipboard.writeText(actualizador).then(() => {
                this.pushMessage('mantenimientoVersionesEtiquetado.portapapeles');
            });
        }
    }

    public trackByVersionSwId(index: number, versionSw: { id: number }): number {
        return versionSw.id;
    }
}